import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import Cookies from 'js-cookie';
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import config from '../functions/config';



const UserProfile = () => {
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  const sessionId = Cookies.get("sessionid"); // Get session ID from cookies
  console.log("Session ID:", sessionId);

  useEffect(() => {
    const fetchProfileData = async () => {
      // const sessionId = Cookies.get('sessionid'); // Get session ID from cookies
    // console.log("Session ID:", sessionId);

      if (!sessionId) {
        setError('User is not logged in. Please log in to view your profile.');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${config.BASE_URL}/api/profile/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Session-ID': sessionId, // Include session ID in the request headers
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user profile');
        }

        const data = await response.json();
        setUserData(data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-danger">Error: {error}</div>;

  return (

    <div>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        {/* Brand Name */}
        <Link className="navbar-brand" to="/">
          📚 Library 
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Menu */}
        <div className={`navbar-collapse ${isOpen ? "show" : "collapse"}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/success">
                Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/userhome">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile">
                Profile
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/rentalhistory">
                Rented Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/purchasehistory">
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/login" className="btn btn-danger">
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>


      <div className="d-flex align-items-center justify-content-center min-vh-50 mt-5">
  <div className="container" style={{ maxWidth: "600px" }}>
    <h2 className="text-center mb-4 mt-5">User Profile</h2>
    <div className="card shadow-lg">
      <div className="card-body">
        <h5 className="card-title text-center mb-3">Welcome, {userData.username}</h5>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <strong>Email:</strong> {userData.email}
          </li>
          <li className="list-group-item">
            <strong>First name:</strong> {userData.first_name}
          </li>
          <li className="list-group-item">
            <strong>Last name:</strong> {userData.last_name}
          </li>
          <li className="list-group-item">
            <strong>Phone:</strong> {userData.phone_number || 'Not provided'}
          </li>
          <li className="list-group-item">
            <strong>Joined On:</strong> {new Date(userData.date_joined).toLocaleDateString()}
          </li>
          <li className="list-group-item">
            <strong>Last Login:</strong> {new Date(userData.last_login).toLocaleDateString()}
          </li>
        </ul>
        <div className="text-center mt-4">

          <a href='/changepassword'><button className="btn btn-primary">Change Password</button> </a>
        </div>
      </div>
    </div>
  </div>
</div>

    </div>

  );
};

export default UserProfile;
